module.exports = __webpack_public_path__ + "vscode.png?c1d59c738af3ff9d06e8752dd6499281";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vscode.png
// module id = 8
// module chunks = 0